import { render, staticRenderFns } from "./your-library-artists.vue?vue&type=template&id=31a3330c&scoped=true&"
import script from "./your-library-artists.vue?vue&type=script&lang=js&"
export * from "./your-library-artists.vue?vue&type=script&lang=js&"
import style0 from "./your-library-artists.vue?vue&type=style&index=0&id=31a3330c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a3330c",
  null
  
)

export default component.exports